import React from 'react';
import { Modal } from 'react-bootstrap';
import './alert.scss';
import userRemoveIcon from '../../assets/img/user-remove-icon.svg';
import dangerTriangleIcon from '../../assets/img/danger-triangle.svg';

const RemovePopupModal = ({ show, onHide, onDelete, userName, image = "user", content }) => {
    const icon = image === "danger" ? dangerTriangleIcon : userRemoveIcon;

    return (
        <Modal show={show} onHide={onHide} centered className="remove-popup-modal">
            <Modal.Body className="text-center">
                {image === "danger" && (
                    <div className="icon-background">
                        <img src={icon} alt="Remove Icon" className="remove-icon" />
                    </div>
                )}
                {image !== "danger" && (
                    <img src={icon} alt="Remove Icon" className="remove-icon user" />
                )}
                <h5 className="user-name">“ {userName} “</h5>
                <p className='content'>{content}</p>
                <div className="button-container">
                    <button onClick={onHide} className="custom-cancel-button">
                        İptal
                    </button>
                    <button onClick={onDelete} className="custom-delete-button">
                        Sil
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RemovePopupModal;
